import { render, staticRenderFns } from "./codCargoStatus.vue?vue&type=template&id=d8080cda&scoped=true&"
import script from "./codCargoStatus.vue?vue&type=script&lang=js&"
export * from "./codCargoStatus.vue?vue&type=script&lang=js&"
import style0 from "./codCargoStatus.vue?vue&type=style&index=0&id=d8080cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8080cda",
  null
  
)

export default component.exports